import Head from 'next/head';

type Props = {
  children: React.ReactNode;
  title: string;
};

export function Title({ children, title }: Props) {
  const pageTitle = `${title} | Zapier`;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      {children}
    </>
  );
}
